import React from "react";
import { useHistory } from "react-router-dom";
import arrowNext from "../../assets/images/arrowNext.png";

function NewsFeed({ id, name, description, logo }) {
  const history = useHistory();
  const routeToCategory = (feedId) => (e) => {
    e.preventDefault();
    history.push(`/news/${feedId}`);
  };

  return (
    <div className="news-card" onClick={routeToCategory(id)}>
      <div className="news-card-left">
        <span className="news-card-logo">
          <img src={logo} alt={name} />
        </span>
      </div>

      <div className="news-card-info">
        <p className="news-card-title">{name}</p>
        <p className="news-card-description">{description}</p>
      </div>

      <img src={arrowNext} className="news-card-arrow" alt="" />
    </div>
  );
}

export default NewsFeed;
